// extracted by mini-css-extract-plugin
export default {"ranking_poster_feed_img":"UserStyleFeedItem_ranking_poster_feed_img__bbz9T","click_ranking_poster_feed_img":"UserStyleFeedItem_click_ranking_poster_feed_img__H6Vot"};